import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from './servicio-fechas-query.service'


@Injectable({
  providedIn: 'root'
})
export class ServiDataRegionalService {

  locacionSelecccionada=''
  cuencaseleccionada=''
  todalacuenca=false
  arrayActividadesPTW=[]
  arrayActividadesEmpleadosPTW=[]

  constructor(public servicioFechasQueryService:ServicioFechasQueryService,) { }


  dataChart1Default = [
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    }, 
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart1 = [
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    }, 
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart2Default = [
    {
      "name": "Drilling",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Producción",
      "value": 0,
      "arrayDeRegistros":[]
    }, 
    {
      "name": "Workover",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Sísmica",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Proy. & facil.",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Logística",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Mantenimiento",
      "value": 0,
      "arrayDeRegistros":[]
    }
  ];

  dataChart2 = [
    {
      "name": "Drilling",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Producción",
      "value": 0,
      "arrayDeRegistros":[]
    }, 
    {
      "name": "Workover",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Sísmica",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Proy. & facil.",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Logística",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Mantenimiento",
      "value": 0,
      "arrayDeRegistros":[]
    }
  ];

  dataChart3 = [
    {
      "name": "W en alturas ",
      "value": 0
    },
    {
      "name": "W en caliente",
      "value": 0
    },
    {
      "name": "Levantamiento mecánico",
      "value": 0
    },
    {
      "name": "Energías peligrosas",
      "value": 0
    },
    {
      "name": "Confinados",
      "value": 0
    },
    {
      "name": "Hazmat",
      "value": 0
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0
    },
    // {
    //   "name": "Otros",
    //   "value": 0
    // },
  ];

  dataChart3Default = [
    {
      "name": "W en alturas ",
      "value": 0
    },
    {
      "name": "W en caliente",
      "value": 0
    },
    {
      "name": "Levantamiento mecánico",
      "value": 0
    },
    {
      "name": "Energías peligrosas",
      "value": 0
    },
    {
      "name": "Confinados",
      "value": 0
    },
    {
      "name": "Hazmat",
      "value": 0
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0
    },
    // {
    //   "name": "Otros",
    //   "value": 0
    // },
  ];

  dataChart4 = [
    {
      "name": "W en alturas ",
      "value": 0,
      "arrayDeRegistros": []
    },
    {
      "name": "W en caliente",
      "value": 0,
      "arrayDeRegistros":[],
    },
    {
      "name": "Levantamiento mecánico",
      "value": 0,
      "arrayDeRegistros":[]

    },
    {
      "name": "Energías peligrosas",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Confinados",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Hazmat",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Otros",
      "value": 0,
      "arrayDeRegistros":[]
    },
  ];

  arrayParaGraficaDeDataset=[
    {
      "name": "W en alturas ",
      "value": 0,
      "arrayDeRegistros": []
    },
    {
      "name": "W en caliente",
      "value": 0,
      "arrayDeRegistros":[],
    },
    {
      "name": "Levantamiento mecánico",
      "value": 0,
      "arrayDeRegistros":[]

    },
    {
      "name": "Energías peligrosas",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Confinados",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Hazmat",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Otros",
      "value": 0,
      "arrayDeRegistros":[]
    },
  ];

  dataChart4Default = [
    {
      "name": "W en alturas ",
      "value": 0,
      "arrayDeRegistros": []
    },
    {
      "name": "W en caliente",
      "value": 0,
      "arrayDeRegistros":[],
    },
    {
      "name": "Levantamiento mecánico",
      "value": 0,
      "arrayDeRegistros":[]

    },
    {
      "name": "Energías peligrosas",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Confinados",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Hazmat",
      "value": 0,
      "arrayDeRegistros":[]
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0,
      "arrayDeRegistros":[]
    },
    // {
    //   "name": "Otros",
    //   "value": 0,
   //    "arrayDeRegistros":[]
    // },
  ];

  dataset=[]


  queryChart1(callback){
    this.resetea(()=>{

    let  fechaquerymin = this.servicioFechasQueryService.fechaquerymin
    let  fechaquerymax = this.servicioFechasQueryService.fechaquerymax
    let  query:any  

    if(this.cuencaseleccionada =='VMM-total'){
      //haciendo query con .where('cuenca','in',['VMM','VMM-otros']) es como un OR. busca todos los items dentro de cuenca que tengan vmm o vmm-otros. Esto sólo funciona como un or dentro del mimso campo. No funciona con otros campos.
      query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where('cuenca','in',['VMM','VMM-otros','VMM - SR & TSQ'])
      
    }else
    if(this.cuencaseleccionada == 'Putumayo-total'){
            //haciendo query con .where('cuenca','in',['VMM','VMM-otros']) es como un OR. busca todos los items dentro de cuenca que tengan vmm o vmm-otros. Esto sólo funciona como un or dentro del mimso campo. No funciona con otros campos.
      query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where('cuenca','in',['Putumayo sur','Putumayo norte'])
      
    }else
    if(this.cuencaseleccionada == 'Ecuador-total'){
            //haciendo query con .where('cuenca','in',['VMM','VMM-otros']) es como un OR. busca todos los items dentro de cuenca que tengan vmm o vmm-otros. Esto sólo funciona como un or dentro del mimso campo. No funciona con otros campos.
      query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where('cuenca','in',['Charapa','Chanangue','Iguana'])
      
    }else{

      console.log ("SELECCION:--> Cualquier otro")

      if(this.todalacuenca==false){
        query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("pozoSeleccionado","==",this.locacionSelecccionada);
       }else
       if(this.todalacuenca==true){
         query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("cuenca","==",this.cuencaseleccionada);
       }

    }

    
      query.get().then((docs)=>{
        docs.forEach((doc)=>{
          
          //no contamos los en diligenciamiento porque pueden tener datos como empresa y trabajadores sin llenar
          if(doc.data().status != 'En diligenciamiento'){
            this.clasificaChart1(doc)
            this.clasificaChart2(doc)
            this.clasificaChart3(doc)
            this.clasificaChart4(doc)
            this.generaDataSet(doc)
          }
         
        })
        // this.dataChart1=[...this.dataChart1]
      }).catch((err)=>{
        console.log(err);
      }).then(()=>{
        callback(this.dataChart1, this.dataChart2, this.dataChart3, this.dataChart4, this.dataset)
      })

    })//resetea
   }



  // queryChart1(callback){
  //   this.resetea(()=>{

  //   let  fechaquerymin = this.servicioFechasQueryService.fechaquerymin
  //   let  fechaquerymax = this.servicioFechasQueryService.fechaquerymax
  //   let  query:any  

  //   if(this.cuencaseleccionada='VMM-total'){

  //   }

  //   if(this.todalacuenca==false){
  //    query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("pozoSeleccionado","==",this.locacionSelecccionada);
  //   }else
  //   if(this.todalacuenca==true){
  //     query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("cuenca","==",this.cuencaseleccionada);
  //   }
  //     query.get().then((docs)=>{
  //       docs.forEach((doc)=>{
  //         this.clasificaChart1(doc)
  //         this.clasificaChart2(doc)
  //       })
  //       // this.dataChart1=[...this.dataChart1]
  //     }).catch((err)=>{
  //       console.log(err);
  //     }).then(()=>{
  //       callback(this.dataChart1, this.dataChart2)
  //     })

  //   })//resetea
  //  }

    clasificaChart1(doc){
      if(doc.data().status == 'Pendiente de aprobación'){this.dataChart1[0].value ++}else
      if(doc.data().status == 'Aprobado' ){this.dataChart1[1].value ++}else
      if(doc.data().status == 'Denegado' ){this.dataChart1[2].value ++}else
      if(doc.data().status == 'cerrado'  ){this.dataChart1[3].value ++}else
      if(doc.data().status == 'Cerrado'  ){this.dataChart1[4].value ++}
    }

    clasificaChart2(doc){
      if(doc.data().unidadDeNegocio =='Drilling' ){
        this.dataChart2[0].value ++
        this.dataChart2[0].name = "Drilling "+this.dataChart2[0].value.toString()
        this.dataChart2[0].arrayDeRegistros.push(doc)
      }else
      if(doc.data().unidadDeNegocio == 'Producción' ){
        this.dataChart2[1].value ++
        this.dataChart2[1].name = "Producción "+this.dataChart2[1].value.toString()
        this.dataChart2[1].arrayDeRegistros.push(doc)
      }else
      if(doc.data().unidadDeNegocio == 'Workover' ){
        this.dataChart2[2].value ++
        this.dataChart2[2].name = "Workover "+this.dataChart2[2].value.toString()
        this.dataChart2[2].arrayDeRegistros.push(doc)
      }else
      if(doc.data().unidadDeNegocio == 'Sísmica'  ){
        this.dataChart2[3].value ++
        this.dataChart2[3].name = "Sísmica "+this.dataChart2[3].value.toString()
        this.dataChart2[3].arrayDeRegistros.push(doc)
      }else
      if(doc.data().unidadDeNegocio == 'Proyectos y facilidades'){
        this.dataChart2[4].value ++
        this.dataChart2[4].name = "Proyectos y facilidades "+this.dataChart2[4].value.toString()
        this.dataChart2[4].arrayDeRegistros.push(doc)
      }
      if(doc.data().unidadDeNegocio == 'Logística'  ){
        this.dataChart2[5].value ++
        this.dataChart2[5].name = "Logística "+this.dataChart2[5].value.toString()
        this.dataChart2[5].arrayDeRegistros.push(doc)
      }
      if(doc.data().unidadDeNegocio == 'Mantenimiento'  ){
        this.dataChart2[6].value ++
        this.dataChart2[6].name = "Mantenimiento "+this.dataChart2[6].value.toString()
        this.dataChart2[6].arrayDeRegistros.push(doc)
      }
    }


    clasificaChart3(doc){
      this.arrayActividadesPTW=[]
        if(doc.data().arrayActividadesPTW == undefined){
          doc.data().arrayDeEmpleados.forEach((empleado) => {
            empleado.arraydeactividades.forEach(actividadTrabajador=>{
              //el some arroja true si hay un item en el array con el parámetro actividad igual 
              if(this.arrayActividadesPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == false){
                 this.arrayActividadesPTW.push(actividadTrabajador.actividad)  
                 this.catalogaPorTareasDataChart3(actividadTrabajador.actividad)       
              }
            })
          });
        }else
        if(doc.data().arrayActividadesPTW != undefined){
          doc.data().arrayActividadesPTW.forEach((element) => {
            //el some arroja true si hay un item en el array con el parámetro actividad igual 
            if(this.arrayActividadesPTW.some((item)=>item.actividad == element.actividad) == false){
              this.arrayActividadesPTW.push(element.actividad)  
              this.catalogaPorTareasDataChart3(element.actividad)       
            }
          });
        }
    }
  
  
    catalogaPorTareasDataChart3(tarea){
      if(tarea == "TRABAJO EN ALTURAS" ){
        this.dataChart3[0].value ++;
        this.dataChart3[0].name="Alturas: "+ this.dataChart3[0].value
      }else
      if(tarea == "TRABAJO EN CALIENTE" ){
        this.dataChart3[1].value ++
        this.dataChart3[1].name="Caliente: "+ this.dataChart3[1].value
      }else
      if(tarea == "LEVANTAMIENTO MECÁNICO" ){
        this.dataChart3[2].value ++
        this.dataChart3[2].name="Levantam: "+ this.dataChart3[2].value
      }else
      if(tarea == "ENERGÍAS PELIGROSAS"){
        this.dataChart3[3].value ++
        this.dataChart3[3].name="Energías: "+ this.dataChart3[3].value
      }else
      if(tarea == "ESPACIOS CONFINADOS"){
        this.dataChart3[4].value ++
        this.dataChart3[4].name="Confinados: "+ this.dataChart3[4].value
      }else
      if(tarea == "HAZMAT"){
        this.dataChart3[5].value ++
        this.dataChart3[5].name="Hazmat: "+ this.dataChart3[5].value
      }else
      if(tarea == "SUPERVISIÓN Y MONITOREO"){
        this.dataChart3[6].value ++
        this.dataChart3[6].name="Superv: "+ this.dataChart3[6].value
      }
      // else 
      // if(tarea == "OTROS"){this.dataChart3[7].value ++}
    }



    clasificaChart4(doc){
      doc.data().arrayDeEmpleados.forEach((empleado) => {
        empleado.arraydeactividades.forEach(actividadTrabajador=>{
          //el some arroja true si hay un item en el array con el parámetro actividad igual 
          if(this.arrayActividadesEmpleadosPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == false){
             this.arrayActividadesEmpleadosPTW.push(actividadTrabajador.actividad)  
             this.catalogaPorTareasDataChart4(actividadTrabajador.actividad,doc)       
          }else
          if(this.arrayActividadesEmpleadosPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == true){
               
          }
        })
      });
    }

  

    catalogaPorTareasDataChart4(tarea,documento){
      if(tarea == "TRABAJO EN ALTURAS" ){
        this.dataChart4[0].value ++
        this.dataChart4[0].name="Alturas: "+ this.dataChart4[0].value
        this.dataChart4[0].arrayDeRegistros.push(documento)
      }else
      if(tarea == "TRABAJO EN CALIENTE" ){
        this.dataChart4[1].value ++
        this.dataChart4[1].name="Caliente: "+ this.dataChart4[1].value
        this.dataChart4[1].arrayDeRegistros.push(documento)
      }else
      if(tarea == "LEVANTAMIENTO MECÁNICO" ){
        this.dataChart4[2].value ++
        this.dataChart4[2].name="Levantam: "+ this.dataChart4[2].value
        this.dataChart4[2].arrayDeRegistros.push(documento)
      }else
      if(tarea == "ENERGÍAS PELIGROSAS"){
        this.dataChart4[3].value ++
        this.dataChart4[3].name="Energías: "+ this.dataChart4[3].value
        this.dataChart4[3].arrayDeRegistros.push(documento)
      }else
      if(tarea == "ESPACIOS CONFINADOS"){
        this.dataChart4[4].value ++
        this.dataChart4[4].name="Confinados: "+ this.dataChart4[4].value
        this.dataChart4[4].arrayDeRegistros.push(documento)
      }else
      if(tarea == "HAZMAT"){
        this.dataChart4[5].value ++
        this.dataChart4[5].name="Hazmat: "+ this.dataChart4[5].value
        this.dataChart4[5].arrayDeRegistros.push(documento)
      }else
      if(tarea == "SUPERVISIÓN Y MONITOREO"){
        this.dataChart4[6].value ++
        this.dataChart4[6].name="Superv: "+ this.dataChart4[6].value
        this.dataChart4[6].arrayDeRegistros.push(documento)
      }
      //else 
      // if(tarea == "OTROS"){
      //   this.dataChart4[7].value ++
      //   this.dataChart4[7].name="Superv: "+ this.dataChart4[7].value
      // }
    }




    resetea(callback){
      this.dataChart1[0].value=0
      this.dataChart1[1].value=0
      this.dataChart1[2].value=0
      this.dataChart1[3].value=0
      this.dataChart1[4].value=0

      this.dataChart2[0].value=0
      this.dataChart2[1].value=0
      this.dataChart2[2].value=0
      this.dataChart2[3].value=0
      this.dataChart2[4].value=0
      this.dataChart2[5].value=0
      this.dataChart2[6].value=0

      this.dataChart3[0].value=0
      this.dataChart3[1].value=0
      this.dataChart3[2].value=0
      this.dataChart3[3].value=0
      this.dataChart3[4].value=0
      this.dataChart3[5].value=0
      this.dataChart3[6].value=0
      // this.dataChart3[7].value=0

      this.dataChart4[0].value=0
      this.dataChart4[1].value=0
      this.dataChart4[2].value=0
      this.dataChart4[3].value=0
      this.dataChart4[4].value=0
      this.dataChart4[5].value=0
      this.dataChart4[6].value=0

      callback()
    }


    
    generaDataSet(doc){

      if( this.containsName(this.dataset, doc.data().empresa).found == false){
       
        let objectToBePushed={
          empresa:doc.data().empresa, 
          totalTrabajadores:doc.data().arrayDeEmpleados.length,
          tickets:doc.data().ticket, 
          totalPTWS:1,  
          alturas:0,
          energias:0,
          hazmat:0,
          confinados:0,
          levantamiento:0,
          calientes:0,
          supervision:0,
          otros:0,
          firebaseDoc:doc,
        }

        if(doc.data().empresa =='' || doc.data().empresa == undefined){
          objectToBePushed.empresa = '(?)->'+doc.data().ticket
        }



        doc.data().arrayDeEmpleados.forEach((trabajador)=>{
          trabajador.arraydeactividades.forEach((actividad) => {
            if(actividad.actividad == "TRABAJO EN ALTURAS"){
              objectToBePushed.alturas ++
            }else
            if(actividad.actividad == "TRABAJO EN CALIENTE"){
              objectToBePushed.calientes ++
            }else
            if(actividad.actividad == "ENERGÍAS PELIGROSAS"){
              objectToBePushed.energias ++
            }else
            if(actividad.actividad == "ESPACIOS CONFINADO"){
              objectToBePushed.confinados ++
            }else
            if(actividad.actividad == "LEVANTAMIENTO MECÁNICO"){
              objectToBePushed.levantamiento ++
            }else
            if(actividad.actividad == "HAZMAT"){
              objectToBePushed.hazmat ++
            }else
            if(actividad.actividad == "SUPERVISIÓN Y MONITOREO"){
              objectToBePushed.supervision ++
            }else
            if(actividad.actividad == "OTROS"){
              objectToBePushed.otros ++      
            }
          });
        })

        this.dataset.push(objectToBePushed)

      }else
      if( this.containsName(this.dataset, doc.data().empresa).found == true){

        this.dataset[this.containsName(this.dataset,doc.data().empresa).index].totalTrabajadores += doc.data().arrayDeEmpleados.length
        this.dataset[this.containsName(this.dataset,doc.data().empresa).index].totalPTWS ++
        this.dataset[this.containsName(this.dataset,doc.data().empresa).index].tickets = this.dataset[this.containsName(this.dataset,doc.data().empresa).index].tickets + " | " +  doc.data().ticket

        doc.data().arrayDeEmpleados.forEach((trabajador)=>{
          trabajador.arraydeactividades.forEach((actividad) => {
            if(actividad.actividad == "TRABAJO EN ALTURAS"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].alturas ++
            }else
            if(actividad.actividad == "TRABAJO EN CALIENTE"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].calientes ++
            }else
            if(actividad.actividad == "ENERGÍAS PELIGROSAS"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].energias ++
            }else
            if(actividad.actividad == "ESPACIOS CONFINADO"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].confinados ++
            }else
            if(actividad.actividad == "LEVANTAMIENTO MECÁNICO"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].levantamiento ++
            }else
            if(actividad.actividad == "HAZMAT"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].hazmat ++
            }else
            if(actividad.actividad == "SUPERVISIÓN Y MONITOREO"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].supervision ++
            }else
            if(actividad.actividad == "OTROS"){
              this.dataset[this.containsName(this.dataset,doc.data().empresa).index].otros ++
            }
          });
        })
      
      }    
  }



 









    //BUSCA SI EN EL PARAMETRO NAME DEL ARRAY DE SALIDA EXISTE EL NAME QUE ENTRA A LA FUNCION. SI SI EXISTE, RETORNA EL INDICE DONDE EST´A
  containsName(outputArray, empresaInput) {
    const index = outputArray.findIndex(item => item.empresa === empresaInput);
    return {
      found: index !== -1,
      index: index
    };
  }









}//fin de clase
